export const MOCK_ACCOUNT_BUTTON_PROPS = {
  name: 'John Doe',
  imageSrc: 'https://picsum.photos/100',
  email: 'john@gmail.com',
  userId: 1,
  avatarClassName: 'w-7 h-7',
  backgroundColor: '#000',
}
